import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { posterUrl, backdropUrl, getMediaType } from "../services/tmdb";

function CarouselItem(props) {
  const navigate = useNavigate();

  const handleClick = () => {
    const type = props.mediaType || getMediaType(props);
    navigate(`/details/${type}/${props.id}`);
  };

  const backdrop = props.backdropPath ? backdropUrl(props.backdropPath) : null;
  const poster = props.posterPath ? posterUrl(props.posterPath) : null;
  const heroImage = backdrop || poster;

  return (
    <div className={"carousel-item " + (props.active ? "active" : "")}>
      <div className="image-container d-flex align-items-center">
        {heroImage ? (
          <>
            <img className="hero-bg" src={heroImage} alt={props.title + " background"} />
            <div className="hero-content">
              <div className="hero-text-container">
                <h1 className="movie-title">{props.title}</h1>
                <div className="movie-meta">
                  <span className="movie-tag movie-rating">⭐ {props.rating ? Number(props.rating).toFixed(1) : "N/A"}</span>
                  <span className="movie-tag">({props.voteCount?.toLocaleString() || 0} votes)</span>
                  <span className="text-secondary d-none d-md-inline">&bull;</span>
                  {props.year && <span className="movie-tag">{props.year}</span>}
                  {props.genres && <span className="movie-tag">{props.genres}</span>}
                </div>
                <p className="movie-plot">{props.overview}</p>
                <div className="mt-4">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={handleClick}
                    className="btn"
                    style={{ backgroundColor: "var(--accent)", color: "#000", fontWeight: "bold", padding: "10px 30px", borderRadius: "30px" }}
                  >
                    View Details
                  </motion.button>
                </div>
              </div>
              {poster && <img className="hero-poster-img" src={poster} alt={props.title} />}
            </div>
          </>
        ) : (
          <div className="skeleton-loader w-100 h-100 position-absolute"></div>
        )}
      </div>
    </div>
  );
}

export default CarouselItem;
